/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Edit_HintInputs */

const en_directory_submit_review_edit_hint = /** @type {(inputs: Directory_Submit_Review_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit details in My Tools`)
};

const zh_directory_submit_review_edit_hint = /** @type {(inputs: Directory_Submit_Review_Edit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 My Tools 中编辑详情`)
};

/**
* | output |
* | --- |
* | "Edit details in My Tools" |
*
* @param {Directory_Submit_Review_Edit_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_edit_hint = /** @type {((inputs?: Directory_Submit_Review_Edit_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Edit_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_edit_hint(inputs)
	return zh_directory_submit_review_edit_hint(inputs)
});
export { directory_submit_review_edit_hint as "directory.submit.review.edit_hint" }